import { useEffect, useRef, useState } from "react";
import {
    claveServidor, descartadoReciente, descartarOferta, EVENTO_OFRECER, puedeOfrecerPush, suscribirPush,
} from "utils/pushNotificaciones";

/* Pregunta, en el momento oportuno, si el cliente quiere recibir avisos en su celular o computador (notificaciones push):
   - al abrir un concierto: novedades y ultimas entradas de ese concierto
   - al registrar una compra: "tus boletos estan listos"
   Primero sale este aviso propio; el cuadro del navegador solo aparece si el cliente toca "Sí, avisarme". Si dice "Ahora no"
   no se le vuelve a ofrecer en 14 dias. Si ya habia aceptado antes, no se le pregunta: solo se liga al concierto / compra. */

const TEXTOS = {
    concierto: "¿Te avisamos cuando haya novedades o se estén acabando las entradas de este concierto?",
    compra: "¿Te avisamos apenas tus boletos estén listos?",
};

export default function AvisoPush() {
    const [oferta, setOferta] = useState(null); // { motivo, codigoEvento, idCompra, cedula }
    const [listo, setListo] = useState(false);
    const ocupado = useRef(false);

    useEffect(() => {
        const alOfrecer = async (ev) => {
            const d = (ev && ev.detail) || {};
            if (!puedeOfrecerPush()) return;
            // Ya acepto antes: se liga en silencio (sin preguntar)
            if (Notification.permission === "granted") {
                suscribirPush({ codigoEvento: d.codigoEvento, idCompra: d.idCompra, cedula: d.cedula });
                return;
            }
            if (descartadoReciente()) return;
            const clave = await claveServidor();
            if (!clave.habilitado) return;
            setListo(false);
            setOferta({ motivo: d.motivo === "compra" ? "compra" : "concierto", codigoEvento: d.codigoEvento, idCompra: d.idCompra, cedula: d.cedula });
        };
        window.addEventListener(EVENTO_OFRECER, alOfrecer);
        return () => window.removeEventListener(EVENTO_OFRECER, alOfrecer);
    }, []);

    if (!oferta) return null;

    const aceptar = async () => {
        if (ocupado.current) return;
        ocupado.current = true;
        const r = await suscribirPush({ ...oferta, pedirPermiso: true });
        ocupado.current = false;
        if (r.ok) { setListo(true); setTimeout(() => setOferta(null), 3500); }
        else {
            // Si el navegador lo bloquea o falla, no se insiste
            descartarOferta();
            setOferta(null);
        }
    };
    const rechazar = () => { descartarOferta(); setOferta(null); };

    return (
        <div role="dialog" aria-label="Avisos de T-ickets"
            style={{ position: "fixed", left: 16, bottom: 16, zIndex: 2000, maxWidth: 340, background: "#fff", color: "#222", borderRadius: 12,
                boxShadow: "0 6px 24px rgba(0,0,0,.25)", padding: "14px 16px", fontSize: 14, lineHeight: 1.35 }}>
            {listo ? (
                <div>✅ ¡Listo! Te avisaremos por aquí.</div>
            ) : (
                <>
                    <div style={{ marginBottom: 10 }}>🔔 {TEXTOS[oferta.motivo]}</div>
                    <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                        <button type="button" className="btn btn-sm btn-link text-muted" onClick={rechazar}>Ahora no</button>
                        <button type="button" className="btn btn-sm btn-primary" onClick={aceptar}>Sí, avisarme</button>
                    </div>
                </>
            )}
        </div>
    );
}
